module.exports = __webpack_public_path__ + "img/рз_31.b1eba885.png";